import { useEffect, useState } from "react";
import { format } from "date-fns";
import ReactMarkdown from "react-markdown";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import NewsletterSignup from "@/components/NewsletterSignup";

const MD = {
  h2: (p) => <h2 className="font-serif text-xl text-charcoal-800 mt-6 mb-2" {...p} />,
  p: (p) => <p className="text-charcoal-600 leading-relaxed mb-3" {...p} />,
  ul: (p) => <ul className="list-disc pl-5 text-charcoal-600 space-y-1 mb-3" {...p} />,
  a: (p) => <a className="text-terracotta underline" {...p} />,
  strong: (p) => <strong className="text-charcoal-800" {...p} />,
};

function fmtDate(iso) {
  try { return format(new Date(iso), "MMMM d, yyyy"); } catch { return ""; }
}

export default function Updates() {
  const [issues, setIssues] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/newsletters").then((res) => setIssues(res.data)).catch(() => setIssues([]));
  }, []);

  return (
    <div data-testid="page-updates">
      <Seo
        title="Updates & Newsletters"
        description="News and updates from Hola Movers — what's new for people planning a move from the US to Mérida, Mexico."
        path="/updates"
      />
      <section className="relative overflow-hidden bg-sand-100">
        <div className="absolute inset-0 pattern-talavera opacity-[0.05]" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12 py-20 lg:py-28">
          <p className="text-sm uppercase tracking-[0.2em] text-clay-700 font-medium mb-4">Updates</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-charcoal-900 leading-[1.05] max-w-3xl">
            News & newsletters from Hola Movers.
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-6 lg:px-12 py-16 lg:py-20 space-y-10">
        {!issues && <p className="text-charcoal-500">Loading…</p>}
        {issues && issues.length === 0 && (
          <p className="text-charcoal-500" data-testid="updates-empty">No updates published yet — check back soon.</p>
        )}
        {issues && issues.map((n) => (
          <article key={n.id} data-testid={`update-${n.id}`} className="rounded-3xl bg-white border border-sand-200 p-8 lg:p-10 shadow-[0_8px_32px_rgba(44,42,41,0.05)]">
            {n.cover_image && <img src={n.cover_image} alt={n.title} className="mb-6 w-full rounded-2xl object-cover max-h-72" />}
            <p className="text-xs uppercase tracking-[0.15em] text-clay-700 mb-2">{fmtDate(n.published_at)}</p>
            <h2 className="font-serif text-2xl text-charcoal-900 mb-4">{n.title}</h2>
            <ReactMarkdown components={MD}>{n.body}</ReactMarkdown>
          </article>
        ))}
        <div className="pt-4">
          <NewsletterSignup />
        </div>
      </section>
    </div>
  );
}
